import(/* webpackMode: "eager" */ "/app/app/docs/page.tsx");
